import React, { useRef, useState } from 'react';

import { Menu } from '@mui/material';
import { AlineTooltip, SelectButton } from 'src/components';
import { SmallDownArrowIcon } from 'src/components/icons/SmallDownArrowIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  arrowIcon: {
    height: 12,
    marginLeft: theme.spacing(0.25),
    width: 12,
  },
  selectButton: {
    height: 32,
    width: 46,
  },
}));

interface ButtonMenuProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  onClose: () => void;
  onOpen: () => void;
  open: boolean;
  tooltip: string;
  disabled?: boolean;
}

// TODO: If changing, consider migrating to DeclarativeMenu
export function ButtonMenu(props: ButtonMenuProps): JSX.Element {
  const { children, disabled, icon, onClose, onOpen, open, tooltip } = props;
  const { classes } = useStyles();

  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  return (
    <>
      <AlineTooltip
        arrow
        open={!open && tooltipOpen}
        placement="bottom"
        title={tooltip}
        onClose={(): void => setTooltipOpen(false)}
        onOpen={(): void => setTooltipOpen(true)}
      >
        <div>
          <SelectButton
            ref={buttonRef}
            className={classes.selectButton}
            disabled={disabled}
            selected={open}
            onClick={(): void => onOpen()}
          >
            {icon}
            <SmallDownArrowIcon className={classes.arrowIcon} />
          </SelectButton>
        </div>
      </AlineTooltip>
      <Menu
        anchorEl={buttonRef.current}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        open={open}
        variant="menu"
        onClose={onClose}
      >
        {children}
      </Menu>
    </>
  );
}
